import './CommentAuthor.scss';
import { AtLeastOne } from '@sonar-software/sonar-ts-types';
import { ConfirmDeleteIcon } from '@ui/modals';
import { convertISODateToHumanReadableDate } from '@sonar-software/sonar-ts-lib';
import { EditOutlined } from '@ant-design/icons';
import React from 'react';
import { SonarText } from '@ui/text';
import { useCurrentUser } from '@hooks';
import { UserNameDisplay } from '@ui/general';
import { Divider, Space } from 'antd';

type RequiredProps = {
	authorUserId: number;
	isCurrentUser: boolean;
};

export type CommentAuthorProps = AtLeastOne<RequiredProps> & {
	commentId?: number;
	createDate?: string;
	onDelete?: () => void;
	onEdit?: () => void;
};

export const CommentAuthor: React.FC<CommentAuthorProps> = ({
	authorUserId,
	commentId,
	createDate,
	isCurrentUser,
	onDelete,
	onEdit
}) => {
	const { id } = useCurrentUser();

	const date = createDate ? convertISODateToHumanReadableDate(createDate) : '';
	const hasAction = onDelete || onEdit;

	return (
		<Space>
			<SonarText weight='semibold'>
				<UserNameDisplay userId={ isCurrentUser ? id : authorUserId ?? 0 } />
			</SonarText>
			{ date &&
				<SonarText
					size={ 12 }
					type='secondary'>
					{ date }
				</SonarText> }
			{ id === authorUserId && hasAction &&
				<div className='comment-actions'>
					{ onEdit &&
						<EditOutlined
							className='edit-button'
							id={ `edit-comment-${commentId}` }
							onClick={ onEdit } /> }
					{ onDelete && onEdit && <Divider type='vertical' /> }
					{ onDelete && <ConfirmDeleteIcon
						id={ `delete-comment-${commentId}` }
						onConfirm={ onDelete } /> }
				</div> }
		</Space>
	);
};
